import axios from 'axios';
import { postClientPayload } from './types';

export const postClient = (data: postClientPayload) => {
  axios
    .post(`http://localhost:8000/api/v1/client/`, data)
    .then(res => {
    })
    .catch(e => {
    });
};
